import React, { useId } from 'react';

interface FeedbackIconProps {
  className?: string;
  size?: number;
}

/**
 * Feedback icon component
 * Displays a chat bubble with star icon for feedback
 */
export const FeedbackIcon: React.FC<FeedbackIconProps> = ({ 
  className = "", 
  size 
}) => {
  const sizeProps = size ? { width: size, height: size } : {};
  const uid = useId();
  const id = (name: string) => `${uid}-${name}`;
  
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 512 512"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient id={id("feedback")}>
          <stop offset="0" style={{ stopColor: '#91d953', stopOpacity: 1 }} />
          <stop offset="1" style={{ stopColor: '#05a9aa', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient
          xlinkHref={`#${id("feedback")}`}
          id={id("feedback-applied")}
          x1="98.090225"
          y1="196.86813"
          x2="413.90976"
          y2="196.86813"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1.5788271,0,0,1.5788271,-148.17972,-54.820742)"
        />
      </defs>
      <g>
        {/* Star */}
        <path
          d="M 406.91325,492.44327 253.70602,410.29134 98.746384,489.1309 130.02957,318.95446 6.6877822,196.87098 179.22906,173.84805 257.95932,19.556726 333.31251,175.50424 505.31222,202.23045 379.34177,321.63419 Z"
          fill={`url(#${id("feedback-applied")})`}
        />
      </g>
    </svg>
  );
};
